import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';

import {AppSettings} from '../app-settings';

import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class ActivityService {

  public token: string;

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
   var currentUser = JSON.parse(localStorage.getItem('currentUser'));
   this.token = currentUser && currentUser.token;
  }

  getActivities(eventId): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/activity/get",{
    params : {
     eventId:eventId
    }
   }).map(response => response.json().activities);
  }

  findActivity(activityId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/activity/find",{
    params : {
     id:activityId
    }
   }).map(response => response.json().activity);
  }

  saveActivity(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/activity/save", params, this.options).map(response => response.json());
  }

  deleteActivity(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/activity/delete", params, this.options).map(response => response.json());
  }

  getActivityQuestions(params): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/activity/get_activity_questions",{
    params : {
     activityId:params.activityId,
     parentOptionId:params.optionId
    }
   }).map(response => response.json().activityQuestions);
  }

  getActivityQuestionsWithOptions(params): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/activity/get_activity_questions_with_options",{
    params : {
     activityId:params.activityId,
    }
   }).map(response => response.json().activityQuestions);
  }

  findActivityQuestion(activityQuestionId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/activity/find_activity_question",{
    params : {
     id:activityQuestionId
    }
   }).map(response => response.json().activityQuestion);
  }

  saveActivityQuestion(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/activity/"+(params.id?'edit_activity_question':'add_activity_question'), params, this.options).map(response => response.json());
  }

  deleteActivityQuestion(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/activity/delete_activity_question", params, this.options).map(response => response.json());
  }

  getActivityQuestionOptions(params): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/activity/get_activity_question_options",{
    params : {
     questionId:params.activityQuestionId
    }
   }).map(response => response.json().activityQuestionOptions);
  }

  findActivityQuestionOption(activityQuestionOptionId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/activity/find_activity_question_option",{
    params : {
     id:activityQuestionOptionId
    }
   }).map(response => response.json().activityQuestionOption);
  }

  saveActivityQuestionOption(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/activity/"+(params.id?'edit_activity_question_option':'add_activity_question_option'), params, this.options).map(response => response.json());
  }

  deleteActivityQuestionOption(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/activity/delete_activity_question_option", params, this.options).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/activity.service.ts